<template>
  <div class="custom-combobox">
    <v-subheader
      class="pa-0"
      v-if="label"
    >
      <label
        for="selection"
        class="neutral-cold-051--text text-body-3"
      >{{ label }}</label>
    </v-subheader>
    <!-- :placeholder="comboboxSetting.label" -->
    <v-combobox
      v-bind="{ ...$attrs }"
      v-on="$listeners"
      item-color="primary-001"
      multiple
      chips
      deletable-chips
      outlined
      v-model="syncLabels"
      :items="searchedLabelsList"
      :search-input.sync="search"
      :hide-no-data="!search || searchedLabelsList.length === 0"
      append-icon=""
    >
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.selected"
          @click:close="data.parent.selectItem(data.item)"
        >
          <p class="mb-0 chip-text">
            {{ data.item }}
          </p>
        </v-chip>
      </template>
      <template v-slot:item="{ index, item }">
        <v-list-item-title
          class="text-body-2 font-weight-medium grey--text text--darken-2"
        >
          {{ item }}
        </v-list-item-title>
      </template>

      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
import defaultReply from '@/restapis/defaultReply';

export default {
  name: 'LabelsComboBox',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    labels: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    syncLabels: {
      get() {
        return this.labels;
      },
      set(v) {
        this.$emit('combobox-input-change', v);
      }
    }
  },
  data() {
    return {
      search: null,
      searchedLabelsList: []
    };
  },
  watch: {
    search(val) {
      if (!val) return;
      if (this.searchedLabelsList.length > 0 && !this.search.length) return;

      this.debouncedFetchLabelList();
    }
  },

  methods: {
    fetchLabelList() {
      const params = {
        labelKeyword: this.search
      };

      defaultReply.getDefaultReplyLabelList(params)
        .then((response) => {
          this.searchedLabelsList = response.data.content.labels;
        })
        .catch((err) => {
          console.log(err);
          this.searchedLabelsList = [];
        });
    }
  },
  created() {
    this.debouncedFetchLabelList = debounce(this.fetchLabelList, 500);
  }
};
</script>
<style lang="scss" scoped>
::v-deep.custom-combobox {
  .v-select__slot {
    input {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      color: $neutral-040;
      &::placeholder {
        color: $neutral-cold-051;
      }
    }
  }

  .v-autocomplete {
    &.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
      padding: 0 6px 0 12px ;
      min-height: 32px;
    }

    // Default Style
    fieldset {
      background: $neutral-cold-056;
      border: none;
      transition: all 0.3s ease-in-out;
    }

    // Hover Style
    &:hover fieldset{
      background: $neutral-cold-054;
    }

    // Focus Style
    &.v-select--is-menu-active fieldset{
      background: $neutral-047;
      border: 1px solid $primary-001;
      box-shadow: 0px 0px 0px 2px rgba(64, 143, 255, 0.25);
    }

    // Disabled Style
    &.v-input--is-disabled {
      fieldset {
        background: $neutral-cold-056;
      }
      & .v-select__slot input {
        color: $neutral-043;
      }
    }

    // Error Style
    &.error--text {
      fieldset {
        background: $neutral-047;
      }
    }
    & .v-messages{
      margin-top: 2px;
      margin-left: 22px;
    }
    & .v-input__append-outer {
      position: absolute;
      bottom: -3px;
      left: 0;
      margin-left: 0;
      display: none;
    }
    &.error--text .v-input__append-outer {
      display: inline-flex;
    }

    // Arrow icon Style
    &.v-select--is-menu-active, .v-input--is-focused {
      & .v-input__icon--append .v-icon {
        color: $neutral-042 !important;
        caret-color: $neutral-042 !important;
      }
    }

    &.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-input--dense .v-select__selections {
      min-height: 32px;
      padding: 2px 0;
    }
    &.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
      margin-top: 0;
      align-self: center;
    }
    &.v-select--is-multi.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections {
      min-height: 32px;
      padding: 2px 0;
    }
    &:not(.v-input--is-disabled).v-select.v-text-field input {
      min-height: 32px;
    }
    &.v-select--is-multi .v-input__append-inner {
      margin-top: 7px;
    }
  }
}

.chip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
